/* NOCTURA — one quiet motion, one variant picker, one gallery. */
(function () {
  'use strict';

  /* ---------- reveal on scroll ---------- */

  function initReveal(root) {
    var scope = root || document;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = scope.querySelectorAll('.reveal:not(.is-in)');
    if (!items.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        setTimeout(function () { el.classList.add('is-in'); }, i * 70);
        io.unobserve(el);
      });
    }, { threshold: 0, rootMargin: '0px 0px -6% 0px' }); /* threshold 0: an element taller than the viewport (a lone search card) still reveals when only its top is in view */

    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- newsletter inline feedback ----------
     Shopify handles the actual submit; this only catches
     an obviously incomplete address before the round trip. */

  function initSignup(root) {
    var scope = root || document;
    scope.querySelectorAll('.signup form').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';
      var done = form.parentElement.querySelector('[data-signup-done]');
      form.addEventListener('submit', function (e) {
        var input = form.querySelector('input[type="email"]');
        if (!input) return;
        var v = input.value.trim();
        if (!v || v.indexOf('@') < 1 || v.lastIndexOf('.') < v.indexOf('@')) {
          e.preventDefault();
          if (done) done.textContent = 'That address looks incomplete — check it and try again.';
          input.focus();
        }
      });
    });
  }

  /* ---------- product: variant selection + media ---------- */

  function initProduct(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-product]').forEach(function (el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';

      var dataEl = el.querySelector('[data-variants]');
      if (!dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

      var idInput   = el.querySelector('[data-variant-id]');
      var priceEl   = el.querySelector('[data-price]');
      var submitEl  = el.querySelector('[data-add]');
      var inputs    = el.querySelectorAll('[data-option]');
      var moneyFmt  = el.dataset.moneyFormat || '${{amount}}';

      function money(cents) {
        var amount = (cents / 100).toFixed(2);
        var parts = amount.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return moneyFmt.replace(/\{\{\s*amount\s*\}\}/, parts.join('.'));
      }

      function selected() {
        var opts = [];
        inputs.forEach(function (input) {
          if (input.checked) opts[parseInt(input.dataset.option, 10)] = input.value;
        });
        return opts;
      }

      function match(opts) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var ok = true;
          for (var j = 0; j < opts.length; j++) {
            if (opts[j] !== undefined && v.options[j] !== opts[j]) { ok = false; break; }
          }
          if (ok) return v;
        }
        return null;
      }

      function showMedia(id) {
        if (!id) return;
        var target = el.querySelector('[data-media-id="' + id + '"]');
        if (!target) return;
        el.querySelectorAll('[data-media-id]').forEach(function (m) { m.hidden = true; });
        target.hidden = false;
        el.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', String(t.dataset.thumb === String(id)));
        });
      }

      function update() {
        var variant = match(selected());

        if (idInput) idInput.value = variant ? variant.id : '';

        if (priceEl) {
          if (!variant) {
            priceEl.textContent = '—';
          } else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceEl.innerHTML = '<s>' + money(variant.compare_at_price) + '</s>' + money(variant.price);
          } else {
            priceEl.textContent = money(variant.price);
          }
        }

        if (submitEl) {
          if (!variant) {
            submitEl.disabled = true;
            submitEl.textContent = submitEl.dataset.unavailable || 'Unavailable';
          } else if (!variant.available) {
            submitEl.disabled = true;
            submitEl.textContent = submitEl.dataset.soldOut || 'Sold out';
          } else {
            submitEl.disabled = false;
            var addText = submitEl.dataset.addLabel || 'Add to cart';
            /* Product Page v2: "Add to cart · $91.98" — price × quantity */
            if (submitEl.hasAttribute('data-add-total')) {
              var qtyEl = el.querySelector('input[name="quantity"]');
              var q = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
              addText += ' · ' + money(variant.price * q);
            }
            submitEl.textContent = addText;
          }
        }

        if (variant) {
          showMedia(variant.featured_media_id);
          if (window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          }
        }
      }

      inputs.forEach(function (input) { input.addEventListener('change', update); });

      var qtyInput = el.querySelector('input[name="quantity"]');
      if (qtyInput && submitEl && submitEl.hasAttribute('data-add-total')) {
        qtyInput.addEventListener('change', update);
        qtyInput.addEventListener('input', update);
      }

      el.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.addEventListener('click', function () { showMedia(t.dataset.thumb); });
      });

      update();
    });
  }

  /* ---------- quantity steppers ---------- */

  function initQty(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-qty]').forEach(function (wrap) {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.dataset.qtyStep, 10);
          var min = parseInt(input.min || '1', 10);
          var next = (parseInt(input.value, 10) || min) + step;
          input.value = Math.max(min, next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- floating masthead ----------
     Publishes the header's height as --header-h so the hero can reserve room
     for it, and swaps the header from transparent to frosted once the artwork
     has scrolled past. Bound once, not per-section. */

  function initHeader() {
    var header = document.querySelector('.masthead');
    if (!header || header.dataset.bound) return;
    header.dataset.bound = '1';

    function measure() {
      document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
    }

    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        header.classList.toggle('is-stuck', window.scrollY > header.offsetHeight);
        ticking = false;
      });
    }

    measure();
    onScroll();

    if ('ResizeObserver' in window) {
      new ResizeObserver(measure).observe(header);
    } else {
      window.addEventListener('resize', measure);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- mobile navigation ----------
     Above the breakpoint the panel is always open and the toggle is hidden,
     so none of this runs on desktop except the resize reset. */

  var navBound = false;

  function initNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    if (!toggle || toggle.dataset.bound) return;
    toggle.dataset.bound = '1';

    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;

    function set(open) {
      toggle.setAttribute('aria-expanded', String(open));
      panel.classList.toggle('is-open', open);
    }

    toggle.addEventListener('click', function () {
      set(toggle.getAttribute('aria-expanded') !== 'true');
    });

    panel.addEventListener('click', function (e) {
      if (e.target.closest('a')) set(false);
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 860) set(false);
    });

    /* Document-level listeners bind once — the header can re-render in the
       theme editor, and these would otherwise stack up. */
    if (navBound) return;
    navBound = true;

    function current() {
      return document.querySelector('[data-nav-toggle]');
    }

    document.addEventListener('keydown', function (e) {
      var t = current();
      if (e.key !== 'Escape' || !t || t.getAttribute('aria-expanded') !== 'true') return;
      t.click();
      t.focus();
    });

    document.addEventListener('click', function (e) {
      var t = current();
      if (!t || t.getAttribute('aria-expanded') !== 'true') return;
      if (e.target.closest('.masthead')) return;
      t.click();
    });
  }

  /* ---------- cart drawer ----------
     Bound once on document rather than per-element: the drawer's markup is
     replaced wholesale after every cart change, so anything bound to the old
     nodes would be thrown away. Open/closed state lives on <html> for the same
     reason — keeping it inside the section would slam the drawer shut on each
     refresh.

     Every path degrades: with no JavaScript the add-to-cart form posts
     normally and the header cart link goes to /cart. */

  var cart = (function () {
    var pending = 0;
    var timers = {};
    var lastFocus = null;

    function root() {
      var s = window.Shopify;
      return (s && s.routes && s.routes.root) || '/';
    }

    function host()  { return document.getElementById('shopify-section-cart-drawer'); }
    function panel() { return document.querySelector('[data-drawer-panel]'); }
    function isOpen() { return document.documentElement.classList.contains('drawer-open'); }

    /* `opener` is passed explicitly rather than read from document.activeElement:
       a click doesn't reliably focus the thing that was clicked, and without it
       Escape would drop focus on <body> instead of where the user left it. */
    function open(opener) {
      if (!host() || isOpen()) return;
      lastFocus = opener || document.activeElement;
      document.documentElement.classList.add('drawer-open');
      var p = panel();
      if (p) p.focus();
    }

    function close() {
      if (!isOpen()) return;
      document.documentElement.classList.remove('drawer-open');
      if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
      lastFocus = null;
    }

    function busy(on) {
      pending += on ? 1 : -1;
      var el = document.querySelector('[data-drawer]');
      if (el) el.setAttribute('aria-busy', pending > 0 ? 'true' : 'false');
    }

    function fail(message) {
      var el = document.querySelector('[data-drawer-error]');
      if (el) el.textContent = message || '';
    }

    function syncCount() {
      var el = document.querySelector('[data-drawer]');
      if (!el) return;
      var n = el.getAttribute('data-cart-total') || '0';
      document.querySelectorAll('[data-cart-count]').forEach(function (slot) {
        slot.textContent = n;
      });
    }

    /* Section Rendering API — one request returns the whole drawer re-rendered
       against the new cart, so totals, discounts and line prices stay in
       Liquid's hands rather than being recomputed in JavaScript. */
    function refresh() {
      return fetch(root() + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var markup = data['cart-drawer'];
          var target = host();
          if (!markup || !target) return;

          var parsed = new DOMParser().parseFromString(markup, 'text/html');
          var fresh = parsed.getElementById('shopify-section-cart-drawer');
          target.innerHTML = fresh ? fresh.innerHTML : markup;

          initQty(target);
          syncCount();
          if (isOpen()) {
            var p = panel();
            if (p) p.focus();
          }
        });
    }

    function read(r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || '');
        return d;
      });
    }

    function change(line, quantity) {
      busy(true);
      fail('');
      return fetch(root() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(read)
        .then(refresh)
        .catch(function (e) { fail(e.message || 'That didn’t go through — try again.'); })
        .then(function () { busy(false); });
    }

    /* 2026-10-17 patch 1: `submitter` is the button that was pressed (the
       phone sticky bar or a "Pair it" quick add), so focus goes back to it
       when the drawer closes instead of jumping to the form's own button. */
    function add(form, submitter) {
      var trigger = submitter || form.querySelector('[data-add]');
      busy(true);
      fail('');
      return fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(read)
        .then(refresh)
        .then(function () { open(trigger); })
        .catch(function (e) {
          open(trigger);
          fail(e.message || 'That didn’t go through — try again.');
        })
        .then(function () { busy(false); });
    }

    function bind() {
      if (document.documentElement.dataset.cartBound) return;
      document.documentElement.dataset.cartBound = '1';

      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
        if (!host()) return;                    /* no drawer — let it post */
        e.preventDefault();
        if (form.dataset.busy) return;          /* guards a double submit without
                                                   touching the button's disabled
                                                   state, which the variant picker
                                                   owns */
        form.dataset.busy = '1';
        add(form, e.submitter || null).then(function () { delete form.dataset.busy; });
      });

      document.addEventListener('click', function (e) {
        if (!e.target.closest) return;

        var opener = e.target.closest('[data-cart-open]');
        if (opener && host()) {
          e.preventDefault();
          open(opener);
          return;
        }

        if (e.target.closest('[data-drawer-close]')) {
          close();
          return;
        }

        var remove = e.target.closest('[data-line-remove]');
        if (remove) change(parseInt(remove.getAttribute('data-line-remove'), 10), 0);
      });

      /* Steppers fire change events as fast as they're clicked; collapse a
         burst into the one request that reflects where the user landed. */
      document.addEventListener('change', function (e) {
        var input = e.target.closest && e.target.closest('[data-line-qty]');
        if (!input) return;
        var line = parseInt(input.getAttribute('data-line-qty'), 10);
        clearTimeout(timers[line]);
        timers[line] = setTimeout(function () {
          change(line, Math.max(0, parseInt(input.value, 10) || 0));
        }, 300);
      });

      document.addEventListener('keydown', function (e) {
        if (!isOpen()) return;

        if (e.key === 'Escape') { close(); return; }
        if (e.key !== 'Tab') return;

        var p = panel();
        if (!p) return;

        var stops = p.querySelectorAll(
          'a[href], button:not([disabled]), input:not([type="hidden"]), textarea, select'
        );
        if (!stops.length) return;

        var first = stops[0];
        var last = stops[stops.length - 1];

        if (e.shiftKey && (document.activeElement === first || document.activeElement === p)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    }

    return { bind: bind, sync: syncCount };
  })();

  /* ---------- size visualiser ----------
     Two views over the same true-to-scale rectangles. Clicking one drives the
     real variant radio, so price, media and URL all follow through the existing
     product code rather than a second copy of it. */

  function initSizer(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-sizer]').forEach(function (sizer) {
      if (sizer.dataset.bound) return;
      sizer.dataset.bound = '1';

      var index = sizer.getAttribute('data-sizer-option');
      var product = sizer.closest('[data-product]');
      var out = sizer.querySelector('[data-sizer-out]');
      var prints = sizer.querySelectorAll('[data-sizer-size]');

      function options() {
        return product ? product.querySelectorAll('[data-option="' + index + '"]') : [];
      }

      function show(value) {
        prints.forEach(function (print) {
          var on = print.getAttribute('data-sizer-size') === value;
          print.setAttribute('aria-pressed', String(on));
          if (on && out) out.textContent = print.getAttribute('data-sizer-readout');
        });
      }

      prints.forEach(function (print) {
        print.addEventListener('click', function () {
          var value = print.getAttribute('data-sizer-size');
          options().forEach(function (input) {
            if (input.value !== value || input.checked) return;
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
          show(value);
        });
      });

      options().forEach(function (input) {
        input.addEventListener('change', function () {
          if (input.checked) show(input.value);
        });
      });

      sizer.querySelectorAll('[data-sizer-view]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var view = tab.getAttribute('data-sizer-view');
          sizer.querySelectorAll('[data-sizer-view]').forEach(function (other) {
            other.setAttribute('aria-pressed', String(other === tab));
          });
          sizer.querySelectorAll('[data-sizer-stage]').forEach(function (stage) {
            stage.hidden = stage.getAttribute('data-sizer-stage') !== view;
          });
        });
      });

      var checked = '';
      options().forEach(function (input) { if (input.checked) checked = input.value; });
      show(checked);
    });
  }

  function boot(root) {
    initReveal(root);
    initSignup(root);
    initProduct(root);
    initQty(root);
    initSizer(root);
  }

  function start() {
    initHeader();
    initNav();
    /* ==== NOCTURA size patch -- append at END of assets/noctura.js ==== */

/* noctura-size.js -- makes the size picker mean something.
   Reads the cm dimensions straight out of each option label, so it keeps
   working if sizes are added or renamed. No dependency on noctura.js internals. */
(function () {
  var MIN = 0.55; // smallest size still renders large enough to judge the art

  function dims(label) {
    // matches "21x29.7 cm / 8x12"", "A3 (29.7 x 42  cm)", "A1 (59.4 x 84.1 cm)"
    var m = String(label).match(/(\d+(?:\.\d+)?)\s*[x\u00d7]\s*(\d+(?:\.\d+)?)\s*(?:cm)?/i);
    if (!m) return null;
    var w = parseFloat(m[1]), h = parseFloat(m[2]);
    if (!w || !h) return null;
    return { w: w, h: h };
  }

  // A-series lookup by real dimensions, so "21x29.7 cm / 8x12"" reads as A4
  var ASERIES = [[841,1189,'A0'],[594,841,'A1'],[420,594,'A2'],[297,420,'A3'],
                 [210,297,'A4'],[148,210,'A5']];
  function niceName(label, d) {
    var m = String(label).match(/\b(A[0-9])\b/i);
    if (m) return m[1].toUpperCase();
    if (d) {
      for (var i = 0; i < ASERIES.length; i++) {
        var w = ASERIES[i][0] / 10, h = ASERIES[i][1] / 10;
        if (Math.abs(d.w - w) < 1.2 && Math.abs(d.h - h) < 1.2) return ASERIES[i][2];
      }
    }
    return String(label).split('/')[0].trim();
  }

  function init(root) {
    var media = root.querySelector('.product__media');
    if (!media) return;

    var radios = root.querySelectorAll('input[type="radio"][data-option]');
    if (!radios.length) return;

    // collect every size on this product so scale is relative to ITS range
    var all = [], i;
    for (i = 0; i < radios.length; i++) {
      var d = dims(radios[i].value);
      if (d) all.push(d.h);
    }
    if (all.length < 2) return;
    var lo = Math.min.apply(null, all), hi = Math.max.apply(null, all);

    var cap = document.createElement('div');
    cap.className = 'np-size';
    cap.innerHTML = '<span class="np-size__name"></span>' +
                    '<span class="np-size__dims"></span>' +
                    '<span class="np-size__bar"></span>';
    media.appendChild(cap);
    var nameEl = cap.querySelector('.np-size__name');
    var dimEl  = cap.querySelector('.np-size__dims');

    function apply(label) {
      var d = dims(label);
      if (!d) return;
      var scale = hi === lo ? 1 : MIN + (1 - MIN) * ((d.h - lo) / (hi - lo));
      media.style.setProperty('--np-scale', scale.toFixed(3));
      cap.style.setProperty('--np-scale', scale.toFixed(3));
      nameEl.textContent = niceName(label, d);
      dimEl.textContent = d.w + ' \u00d7 ' + d.h + ' cm  \u00b7  ' +
        (d.w / 2.54).toFixed(1) + ' \u00d7 ' + (d.h / 2.54).toFixed(1) + ' in';
    }

    // Relabel any size that has no A-code of its own (Gelato ships the smallest
    // as "21x29.7 cm / 8x12\"") so the ladder reads A4 \u00b7 A3 \u00b7 A2 \u00b7 A1.
    // Display only - the radio's value is untouched, so the Gelato variant
    // mapping and the cart are unaffected.
    for (i = 0; i < radios.length; i++) {
      var d0 = dims(radios[i].value);
      if (!d0) continue;
      if (!/\b(A[0-9])\b/i.test(radios[i].value)) {
        var code = niceName(radios[i].value, d0);
        if (/^A[0-9]$/.test(code)) {
          var span = radios[i].parentNode.querySelector('span');
          if (span) span.textContent = code + ' (' + d0.w + ' x ' + d0.h + ' cm)';
        }
      }
    }

    for (i = 0; i < radios.length; i++) {
      radios[i].addEventListener('change', function () { apply(this.value); });
      if (radios[i].checked) apply(radios[i].value);
    }
    // turn size animations on only after the first size has painted
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { media.classList.add('np-ready'); });
    });
  }

  function boot() {
    var products = document.querySelectorAll('[data-product]');
    for (var i = 0; i < products.length; i++) init(products[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  // Shopify theme editor re-renders sections
  document.addEventListener('shopify:section:load', boot);
})();

    cart.bind();
    cart.sync();
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Re-run inside the theme editor when a section is re-rendered. The header
     itself may be the section that reloaded, so re-bind it too. */
  document.addEventListener('shopify:section:load', function (e) {
    initHeader();
    initNav();
    cart.sync();
    boot(e.target);
  });
})();
